import React from 'react';
import SelectTemplate from '../CampaignDetails/SelectTemplate';

interface EmailToolbarProps {
  setEmailBody: (value: string | ((prev: string) => string)) => void;
  handleTemplateSelect: (template: any) => void;
  templates: any;
}

const EmailToolbar: React.FC<EmailToolbarProps> = ({
  setEmailBody,
  handleTemplateSelect,
  templates
}) => {
  return (
    <div className="email-editor-bottom-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div id="email-editor-toolbar-container" className="email-editor-toolbar-container ">
        <span className="ql-formats" style={{ marginRight: "4px" }}>
          <button className="ql-bold" style={{ fontWeight: 700 }} />
          <button className="ql-italic" />
          <button className="ql-underline" />
          <button className="ql-strike" />
        </span>
        <span className="ql-formats" style={{ marginRight: "4px" }}>
          {/* <button className="ql-list" value="ordered" /> */}
          <button className="ql-list ql-bullet" value="bullet" />
          <button className="ql-link" />
          {/* <button className="ql-indent" value="+1" /> */}
          {/* <button className="ql-indent" value="-1" /> */}
        </span>
      </div>
      <span className="request-usage-rights-select-template-container cursor-pointer">
          <SelectTemplate handleTemplateSelect={handleTemplateSelect} templates={templates} />
      </span>
    </div>
  );
};

export default EmailToolbar;
